<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">
      {{ titleMessage }}
    </h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onClose()"
      title="Close"
    ></i>
  </div>

  <div class="modal-body">
    <div>
      <form
        spellcheck="false"
        autocomplete="off"
        [formGroup]="attachvGPUForm"
        (ngSubmit)="onSubmit(attachvGPUForm)"
      >
        <div class="listTable flex-grow-1" style="white-space: nowrap">
          <div style="overflow-y: auto">
            <!--<mat-form-field appearance="fill" style="width: 90%; margin-left: 4%;">
              <mat-label>vGPU Instance</mat-label>
              <mat-select formControlName="vGpuInstance">
                <mat-option *ngFor='let jp of gpuInstanceList' [value]="jp.id">{{ jp.instanceName }}</mat-option>
              </mat-select>
            </mat-form-field>-->
            <br />
            <mat-form-field
              appearance="fill"
              style="width: 90%; margin-left: 4%"
              *ngIf="action == 'attach'"
            >
              <mat-label>vGPU to attach</mat-label>
              <mat-select formControlName="hostDeviceIdToAttach">
                <mat-option
                  *ngFor="let hd of hostDevicesToAttach"
                  [value]="hd.name"
                  >{{ hd.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
            <br />
            <mat-form-field
              appearance="fill"
              style="width: 90%; margin-left: 4%"
              *ngIf="action == 'detach'"
            >
              <mat-label>vGPU to detach</mat-label>
              <mat-select formControlName="hostDeviceIdToDetach">
                <mat-option
                  *ngFor="let hdetach of hostDevicesToDetach"
                  [value]="hdetach.id"
                  >{{ hdetach.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">
      Close
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onSubmit(attachvGPUForm)"
    >
      Submit
    </button>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0)"
  size="default"
  zIndex="1"
  color="var(--s-primary-color)"
  type="ball-spin"
  [fullScreen]="false"
  name="spinner"
  ><p class="pleaseWait">Please wait ...</p></ngx-spinner
>
